import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Breadcrumbs,
  Button,
  Container,
  Grid,
  Link,
  Typography,
} from "@mui/material";

import useSettings from "../../hooks/useSettings";
import ChevronRightIcon from "../../icons/ChevronRight";
import PlusIcon from "../../icons/Plus";
import ViewAllDepartmentListTable from "../../components/dashboard/department/ViewAllDepartmentListTable";
import useCommons from "../../hooks/useCommons";
import PermissionGuard from "../../components/PermissionGuard";

const ViewAllDepartment = () => {
  const { settings } = useSettings();

  const [showAddDepartmentModal, setShowAddDepartmentModal] = useState(false);
  const { allDepartmentsCount } = useCommons();
  return (
    <>
      <Helmet>
        <title>Dashboard: View All Departemnt</title>
      </Helmet>

      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
        }}
      >
        <Container maxWidth={settings.compact ? "xl" : false}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={3}
          >
            <Grid item>
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={<ChevronRightIcon fontSize="small" />}
                sx={{ mt: 1 }}
              >
                <Link
                  color="textSecondary"
                  component={RouterLink}
                  to="/"
                  variant="breadCrumbText"
                >
                  Dashboard
                </Link>
                <Typography color="textSecondary" variant="breadCrumbText">
                  Departments
                </Typography>
              </Breadcrumbs>
              <Typography color="textPrimary" variant="dashboardHeading">
                Departments
              </Typography>
              <Box
                sx={{
                  mt: 0.5,
                }}
              >
                <Typography
                  color="textSecondary"
                  component="span"
                  variant="dashboardInfo"
                >
                  Total Departments:
                </Typography>
                <Typography
                  component="span"
                  variant="dashboardInfo"
                  sx={{
                    color: "#00000E",
                    pl: 1,
                  }}
                >
                  {allDepartmentsCount}
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box sx={{ m: -1 }}>
                <PermissionGuard
                  permissionCheck="DEPARTMENT_CREATE"
                  returnEmpty={true}
                >
                  <Button
                    color="primary"
                    startIcon={<PlusIcon fontSize="small" />}
                    sx={{ m: 1 }}
                    variant="contained"
                    onClick={() => setShowAddDepartmentModal(true)}
                  >
                    ADD NEW DEPARTMENT
                  </Button>
                </PermissionGuard>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ mt: 3 }}>
            <ViewAllDepartmentListTable
              showAddDepartmentModal={showAddDepartmentModal}
              setShowAddDepartmentModal={setShowAddDepartmentModal}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ViewAllDepartment;
